import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation, type Variables } from '../../../hooks/use-optimistic-mutation';
import { PriceListError } from '../errors';
import type { PriceListApiResponse } from '../types';
import { QK_ALL_PRICE_LISTS, QK_PAGINATED_PRICE_LISTS } from './use-price-lists';
import { usePriceListsApi } from './use-price-lists-api';

export function useClearPriceList() {
  const { priceListsApi } = usePriceListsApi();
  const queryClient = useQueryClient();

  async function clearList(slug: string) {
    try {
      await priceListsApi.priceList(slug).clear();
    } catch {
      throw new PriceListError('clear_failed');
    }
  }

  return useOptimisticMutation<
    PriceListApiResponse[],
    Variables<typeof clearList>,
    PriceListError<'clear_failed'>
  >({
    queryClient,
    queryKey: QK_PAGINATED_PRICE_LISTS(),
    invalidateKeys: [QK_ALL_PRICE_LISTS()],
    mutationFn: (slug) => clearList(slug),
    optimisticUpdate: (prev, slug) =>
      prev?.map((list) => (list.slug === slug ? { ...list, num_manual_prices: 0 } : list)) ?? [],
  });
}
